export const boxRoutePrefix = "/boxes/";
export const adminRoute = "/admin";
export const termsRoute = "/aszf";
export const privacyNoticeRoute = "/adatkezelesi-tajekoztato";
export const rentalAgreementRoute = "/berleti-szerzodes";
export const externalLoginRoutePrefix = "/oauth-complete";
export const resetPasswordRoutePrefix = "/reset-password";

function normalizePath(pathname) {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/g, "");
}

function buildRouteFromUrl(url) {
  const pathname = normalizePath(url.pathname);
  return `${pathname}${url.search}`;
}

export function createBoxRouteSlug(name) {
  return name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getHash() {
  return buildRouteFromUrl(new URL(window.location.href));
}

export function getSelectedBoxId(route) {
  const url = new URL(route || "/", window.location.origin);
  return url.pathname.startsWith(boxRoutePrefix)
    ? url.pathname.replace(boxRoutePrefix, "")
    : null;
}

export function isAdminHash(route) {
  const url = new URL(route || "/", window.location.origin);
  return url.pathname === adminRoute;
}

export function getPasswordResetParams(route) {
  const url = new URL(route || "/", window.location.origin);

  if (url.pathname !== resetPasswordRoutePrefix) {
    return null;
  }

  const email = url.searchParams.get("email") ?? "";
  const token = url.searchParams.get("token") ?? "";

  return email && token ? { email, token } : null;
}

export function getExternalLoginTicket(route) {
  const url = new URL(route || "/", window.location.origin);

  if (url.pathname !== externalLoginRoutePrefix) {
    return null;
  }

  return url.searchParams.get("ticket");
}

export function toRoutePath(pathname, search = "") {
  const normalizedPath = normalizePath(pathname);
  return `${normalizedPath}${search}`;
}
